import styled from 'styled-components'

export const PageFiller = styled.div`
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Wrapper = styled.section`
  margin: 16px;

  text-align: center;
  max-width: 540px;
`

export const IconWrapper = styled.div`
  /* This color should be "Light/colors.foreground.secondary.4" but given the icon composition */
  /* Opacity needs to be applied to the whole object */
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  opacity: 0.55;

  width: 64px;
  height: 64px;

  margin: 0 auto 16px;
`

export const Title = styled.h1`
  margin: 0;

  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`
export const Description = styled.p`
  margin: 0 auto 16px;

  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
`
export const CallToActionWrapper = styled.div`
  margin: 0 auto;
`
